import { InstallationRefusal } from '@core/helpers/installation-refusal.helper';

export interface LinkRefusal {
  messageKey: string;
  // What the link was made on has changed underneath it, so the page must read it again.
  stale: boolean;
}

const KEY_PREFIX = 'installations.link.errors.';

// device-func words this 404 as prose, not as a code like the 409s.
const INSTALLER_UNKNOWN = 'Installer object id does not exist';

function refusal(key: string, stale = false): LinkRefusal {
  return { messageKey: KEY_PREFIX + key, stale };
}

const CONFLICT_REASONS: Record<string, LinkRefusal> = {
  installation_not_active: refusal('installationNotActive', true),
  installation_not_at_location: refusal('installationNotAtLocation', true),
  location_without_coordinates: refusal('locationWithoutCoordinates'),
  device_partner_mismatch: refusal('devicePartnerMismatch'),
  device_not_registered: refusal('deviceNotRegistered'),
  device_already_linked: refusal('deviceAlreadyLinked', true),
  shared_device_timezone_conflict: refusal('timezoneConflict'),
};

function conflictRefusal(reason: string | null): LinkRefusal {
  const known = reason === null ? undefined : CONFLICT_REASONS[reason];
  return known ?? refusal('deviceUnavailable');
}

function missingRefusal(reason: string | null): LinkRefusal {
  return reason === INSTALLER_UNKNOWN ? refusal('installerUnknown') : refusal('gone', true);
}

// Explains a refused link to an installation. A reason the user cannot act on reads like any other
// failure to link.
export function linkRefusal({ status, reason }: InstallationRefusal): LinkRefusal {
  if (status === 409) return conflictRefusal(reason);
  if (status === 401 || status === 403) return refusal('notAllowed');
  if (status === 404) return missingRefusal(reason);
  return refusal('failed');
}
